import React from "react";
import {useThemeSelector} from "./Theme";
import {useState, useEffect} from "react";

const Options = () => {
    const [fontToggled, setFontState] = useState(localStorage.getItem("fontToggled") === "true");
    const toggleFont = () => {
        const fontState = !fontToggled;
        setFontState(fontState);
        localStorage.setItem("fontToggled", fontState);
        //if true
        if (fontState) {
            document.body.style.fontFamily = "Comic Sans MS";
            document.body.style.fontSize = "larger";}
        else{
            document.body.style.fontFamily = null;
            document.body.style.fontSize = null;}
    }
    //allows for toggle switch state to be rendered after page has been
    useEffect(() => {
        if (fontToggled) {
            document.body.style.fontFamily = "Comic Sans MS";
        } else {
            document.body.style.fontFamily = null;
        }
    }, [fontToggled]);

    const { theme, changeTheme } = useThemeSelector();
    return (
        <main>
            <h1 className="heading1">Options</h1>

            {/*https://getbootstrap.com/docs/5.1/forms/checks-radios/*/}
            <section className="options">
                <div className="form-check form-switch">
                    <input className="form-check-input"
                           type="checkbox" role="switch"
                           id="flexSwitchCheckDefault"
                           checked={theme === "dark"}
                           onChange={changeTheme}
                           aria-label="Toggle theme"/>
                    <label className="form-check-label" htmlFor="flexSwitchCheckDefault">
                        Switch to {theme === "light" ? "Dark" : "Light"} Mode
                    </label>
                </div>

                <div className="form-check form-switch">
                    <input className="form-check-input"
                           type="checkbox"
                           id="flexSwitchCheckDefault"
                           checked={fontToggled}
                           onChange={toggleFont}
                           aria-label="Toggle theme"/>
                    <label className="form-check-label" htmlFor="flexSwitchCheckDefault">
                        Accessible Font Styling
                    </label>
                </div>
            </section>
        </main>
    )
};
export default Options;
